import { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField
} from '@mui/material'
import { useGridApiContext } from '@mui/x-data-grid'
import { IModalProps } from 'hooks'
import { COACH_SPECIALTIES, LABEL_BY_COACH_SPECIALTY } from './ChangeSpecialties'

interface IChangeSpecialtiesModalProps extends IModalProps {
  rowId: number
  userId: string
  field: string
}

export const ChangeSpecialtiesModal = (props: IChangeSpecialtiesModalProps) => {
  const { rowId, field, closeModal, modalState } = props

  const apiRef = useGridApiContext()
  const currentValue = apiRef.current.getCellValue(rowId, field)
  const [selectedSpecialties, setSelectedSpecialties] = useState(currentValue)

  const options = COACH_SPECIALTIES.map((specialty) => LABEL_BY_COACH_SPECIALTY[specialty])

  const onChange = (_: any, newValue: any) => {
    setSelectedSpecialties(newValue)
  }

  const onCloseAction = () => {
    closeModal()
    apiRef.current.setEditCellValue({ id: rowId, field, value: selectedSpecialties })
    apiRef.current.stopCellEditMode({ id: rowId, field })
  }

  return (
    <Dialog open={modalState} onClose={onCloseAction}>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          Specialties
          <IconButton aria-label="close" onClick={onCloseAction}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Autocomplete
          multiple
          fullWidth
          value={selectedSpecialties}
          options={options}
          ListboxProps={{ style: { minHeight: '95vh' } }} // needed for setting the popper height; setting it in componentsProps gets overwritten somehow
          componentsProps={{
            popper: {
              placement: 'auto-start',
              modifiers: [
                {
                  name: 'preventOverflow',
                  options: {
                    padding: 20
                  }
                },
                {
                  name: 'offset',
                  options: {
                    offset: [0, 8]
                  }
                }
              ],
              style: {
                width: 375
              }
            },
            paper: {
              style: {
                backgroundColor: '#FAFAFA',
                boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
              }
            }
          }}
          clearOnEscape
          onChange={onChange}
          renderInput={({ inputProps, ...rest }) => {
            return <TextField {...rest} inputProps={{ ...inputProps }} />
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onCloseAction}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  )
}
